export default __webpack_public_path__ + "static/media/h-clientes.970530bc.webp";